
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcGaugeRadial as ObcGaugeRadialElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/gauge-radial/gauge-radial.js';
 
 
 

 
 export const ObcGaugeRadial = createComponent({
   react: React,
   tagName: 'obc-gauge-radial',
   elementClass: ObcGaugeRadialElement,
   events: {
     
   }
  });
 
 